import { createTheme, lightThemePrimitives } from 'baseui';

export const qnareadTheme = createTheme({
  ...lightThemePrimitives,
  primary: '#2563eb',
  primaryA: '#0f172a',
  primaryB: '#ffffff',
  accent: '#0ea5e9',
  colors: {
    backgroundPrimary: '#ffffff',
    backgroundSecondary: '#f8fafc',
    backgroundTertiary: '#f1f5f9',
    contentPrimary: '#0f172a',
    contentSecondary: '#475569',
    contentTertiary: '#64748b',
    borderOpaque: '#e2e8f0',
    borderAccent: '#2563eb',
    contentAccent: '#2563eb',
    modalCloseColor: '#64748b',
    modalCloseColorHover: '#1d4ed8',
    buttonPrimaryFill: '#2563eb',
    buttonPrimaryHover: '#1d4ed8',
    buttonPrimaryActive: '#1e40af',
    buttonSecondaryFill: '#ffffff',
    buttonSecondaryText: '#1d4ed8',
    buttonSecondaryStroke: '#bfdbfe',
    buttonTertiaryText: '#475569',
    linkText: '#2563eb',
    linkHover: '#1d4ed8',
  },
  borders: {
    radius400: '12px',
    radius500: '16px',
  },
});

/** Shared layout overrides for large form modals */
export const qnareadModalDialogOverrides = {
  DialogContainer: {
    style: {
      backgroundColor: 'rgba(15, 23, 42, 0.45)',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)',
    },
  },
  Dialog: {
    style: {
      border: '1px solid #e2e8f0',
      borderRadius: '16px',
      boxShadow:
        '0 24px 48px rgba(15, 23, 42, 0.12), 0 8px 30px rgba(15, 23, 42, 0.07)',
    },
  },
  Close: {
    style: {
      color: '#64748b',
      ':hover': {
        color: '#1d4ed8',
        backgroundColor: '#eff6ff',
      },
    },
  },
};
